import { useNavigate } from "react-router-dom";
import { ContentBox, ContentPage, NoResults } from "@ficatranquilo/contabilidade.com-ui";
import { usePageHeader } from "@components/ow";

// Avisos dentro do AppShell: sem login, o Layout manda para /auth/entrar antes de chegar aqui

function StatusPage({ title, text }) {
  const navigate = useNavigate();

  usePageHeader({ title, breadcrumb: [{ page: title, route: "/" }] });

  return (
    <ContentPage>
      <ContentBox>
        <NoResults notResultText={text} includeText="Ir para o início" includeAction={() => navigate("/")} />
      </ContentBox>
    </ContentPage>
  );
}

export function Unauthorized() {
  return <StatusPage title="Acesso não autorizado" text="Você não tem acesso a esta página" />;
}

export function NoMatch() {
  return <StatusPage title="Página não encontrada" text="Esta página não existe ou mudou de endereço" />;
}
